
import * as CustomKonvaFilters from '../../../custom/filters';

/**
 * Presets shown in the Effects tab — curated for marketing / promo banners.
 * Removed: artistic gimmicks (Invert, Solarize, Sepia), heavy vintage/grunge
 * (Lo-Fi, Toaster, Sutro, 1977, …), duplicate B&W (Inkwell), and obscure clones.
 */
export const AVAILABLE_FILTERS = [
  {
    label: 'Original',
    filterFn: null,
  },
  {
    label: 'Black & White',
    filterFn: CustomKonvaFilters.BlackAndWhite,
  },
  {
    label: 'Clarendon',
    filterFn: CustomKonvaFilters.Clarendon,
  },
  {
    label: 'Gingham',
    filterFn: CustomKonvaFilters.Gingham,
  },
  {
    label: 'Lark',
    filterFn: CustomKonvaFilters.Lark,
  },
  {
    label: 'Juno',
    filterFn: CustomKonvaFilters.Juno,
  },
  {
    label: 'Reyes',
    filterFn: CustomKonvaFilters.Reyes,
  },
  {
    label: 'Slumber',
    filterFn: CustomKonvaFilters.Slumber,
  },
  {
    label: 'Crema',
    filterFn: CustomKonvaFilters.Crema,
  },
  {
    label: 'Ludwig',
    filterFn: CustomKonvaFilters.Ludwig,
  },
  {
    label: 'Aden',
    filterFn: CustomKonvaFilters.Aden,
  },
  {
    label: 'Perpetua',
    filterFn: CustomKonvaFilters.Perpetua,
  },
  {
    label: 'Amaro',
    filterFn: CustomKonvaFilters.Amaro,
  },
  {
    label: 'Mayfair',
    filterFn: CustomKonvaFilters.Mayfair,
  },
  {
    label: 'Rise',
    filterFn: CustomKonvaFilters.Rise,
  },
  {
    label: 'Hudson',
    filterFn: CustomKonvaFilters.Hudson,
  },
  {
    label: 'Valencia',
    filterFn: CustomKonvaFilters.Valencia,
  },
  {
    label: 'Sierra',
    filterFn: CustomKonvaFilters.Sierra,
  },
  {
    label: 'Willow',
    filterFn: CustomKonvaFilters.Willow,
  },
  {
    label: 'Walden',
    filterFn: CustomKonvaFilters.Walden,
  },
  {
    label: 'Maven',
    filterFn: CustomKonvaFilters.Maven,
  },
];
